import React from 'react';
import PropTypes from 'prop-types';
import { compose, withState, withHandlers, pure } from 'recompose';

import {
  StyledOptionsSocialMedia,
  StyledIconCommentsForColumn,
  StyledIconForColumn,
  StyledBoxOption,
  StyledBoxText
} from './style';
import { Like, ReadLater, Share } from '../../../../assets/images/index';

const SocialMediaLayoutColumn = ({
  className,
  activeLike,
  numberIcon,
  activeFavorite,
  onClickAction,
  onComment,
  onShare,
  activeMessage,
  message,
  children
}) => (
  <StyledOptionsSocialMedia className={className}>
    <StyledIconForColumn
      svg={Like}
      size="m"
      active={activeLike}
      onClick={() => onClickAction('LIKE')}
    />
    <StyledIconCommentsForColumn
      size="m"
      numberComments={numberIcon}
      onClick={onComment}
    />
    <StyledIconForColumn
      svg={ReadLater}
      size="m"
      active={activeFavorite}
      onClick={() => onClickAction('FAVORITE')}
    />
    <StyledIconForColumn svg={Share} size="m" onClick={onShare} />

    {children}

    <StyledBoxOption active={activeMessage}>
      <StyledBoxText>{message}</StyledBoxText>
    </StyledBoxOption>
  </StyledOptionsSocialMedia>
);

const enhance = compose(
  withState('activeMessage', 'setActiveMessage', false),
  withState('timer', 'setTimer', null),
  withState('message', 'setMessage', null),
  withHandlers({
    onClickAction: ({
      setActiveMessage,
      setMessage,
      onLike,
      activeLike,
      activeFavorite,
      onFavorite,
      timer,
      setTimer
    }) => value => {
      setActiveMessage(true);

      if (value === 'LIKE') {
        if (activeLike) {
          setMessage('NO ME GUSTA');
        } else {
          setMessage('ME GUSTA');
        }
        onLike();
      } else if (value === 'FAVORITE') {
        if (activeFavorite) {
          setMessage('NO LEER MÁS TARDE');
        } else {
          setMessage('LEER MÁS TARDE');
        }
        onFavorite();
      }

      clearTimeout(timer);

      setTimer(setTimeout(() => setActiveMessage(false), 2000));
    }
  }),
  pure
)(SocialMediaLayoutColumn);

SocialMediaLayoutColumn.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  activeMessage: PropTypes.bool,
  activeFavorite: PropTypes.bool,
  activeLike: PropTypes.bool,
  message: PropTypes.string,
  onShare: PropTypes.func,
  onComment: PropTypes.func,
  numberIcon: PropTypes.number
};

export default enhance;
